import { render } from "./Welcome.vue?vue&type=template&id=0efb8f25&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=0efb8f25&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0efb8f25"

export default script